import { UserRole } from '@heidi/schema/ml-scribe';

/**
 * Live-demo booking in Heidi II onboarding is workspace-admin only.
 * Enterprise members must not be offered a 1:1.
 */
export const canOfferHeidi2OnboardingBookDemo = (
  workspaceRole: string | null | undefined
): boolean => workspaceRole === UserRole.ADMIN;
